import { render, staticRenderFns } from "./message_list.vue?vue&type=template&id=3e3bdaa8&scoped=true&"
import script from "./message_list.vue?vue&type=script&lang=js&"
export * from "./message_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3bdaa8",
  null
  
)

export default component.exports